import styled from 'styled-components'
import { Box } from '@realsoftworks/decor'

const Container = styled(Box)`
  max-width: 1080px;
`

export default Container
